import Vue from 'vue';
import { VRow, VProgressCircular, VCard, VCardText } from 'vuetify/lib';

Vue.component('v-progress-circular', VProgressCircular);
Vue.component('v-row', VRow);
Vue.component('v-card', VCard);
Vue.component('v-card-text', VCardText);

export default Vue.extend({
  template: `
    <v-card width="200">
      <v-card-text>
        <v-row align="center" justify="center">
          <v-progress-circular
            indeterminate
            :size="40"
            color="primary"
          >
          </v-progress-circular>
          <div class="subtitle-1 ml-5">Loading...</div>
        </v-row>   
      </v-card-text>
    </v-card>
  `,
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  }
});